var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 2C4.18261 2 2 4.18261 2 6.875V18.125C2 20.8174 4.18261 23 6.875 23H18.125C20.8174 23 23 20.8174 23 18.125V6.875C23 4.18261 20.8174 2 18.125 2H6.875ZM0.5 6.875C0.5 3.35418 3.35419 0.5 6.875 0.5H18.125C21.6458 0.5 24.5 3.35418 24.5 6.875V18.125C24.5 21.6458 21.6458 24.5 18.125 24.5H6.875C3.35419 24.5 0.5 21.6458 0.5 18.125V6.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0988 8.74186C12.3185 8.62616 11.5217 8.75943 10.8216 9.12271C10.1214 9.48599 9.5537 10.0608 9.19908 10.7653C8.84446 11.4699 8.72103 12.2683 8.84634 13.0471C8.97165 13.8258 9.33932 14.5452 9.89706 15.1029C10.4548 15.6607 11.1742 16.0284 11.9529 16.1537C12.7317 16.279 13.5301 16.1556 14.2347 15.8009C14.9392 15.4463 15.514 14.8786 15.8773 14.1784C16.2406 13.4783 16.3738 12.6815 16.2582 11.9012C16.1401 11.1054 15.7693 10.3686 15.2004 9.79965C14.6314 9.23073 13.8946 8.85988 13.0988 8.74186ZM10.1307 7.79128C11.1109 7.28268 12.2265 7.09611 13.3188 7.25809C14.433 7.42331 15.4645 7.94251 16.261 8.73899C17.0575 9.53547 17.5767 10.567 17.7419 11.6812C17.9039 12.7735 17.7173 13.8891 17.2087 14.8693C16.7001 15.8495 15.8954 16.6443 14.9091 17.1408C13.9227 17.6372 12.8049 17.8101 11.7146 17.6346C10.6244 17.4592 9.61724 16.9444 8.8364 16.1636C8.05557 15.3828 7.54082 14.3756 7.36539 13.2854C7.18995 12.1951 7.36276 11.0773 7.85923 10.091C8.3557 9.10458 9.15054 8.29987 10.1307 7.79128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4375 6.3125C17.4375 5.62214 17.9971 5.0625 18.6875 5.0625H18.697C19.3874 5.0625 19.947 5.62214 19.947 6.3125C19.947 7.00286 19.3874 7.5625 18.697 7.5625H18.6875C17.9971 7.5625 17.4375 7.00286 17.4375 6.3125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.36fb016059e922d91238311d7e8bd6e1.svg";
export { ForwardRef as ReactComponent };